import * as React from 'react';

import ProjectTypeSelectorDesktop from './ProjectTypeSelectorDesktop';
import ProjectTypeSelectorMobile from './ProjectTypeSelectorMobile';
import { IRenderProps } from '../../models/ProjectType';

class ProjectTypeSelector extends React.PureComponent<IRenderProps> {
  state = {
    isMobile: false,
  };

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  isMobile = () => window.innerWidth < 768;

  handleResize = () => {
    this.setState({ isMobile: this.isMobile() });
  };

  render() {
    const { isMobile } = this.state;

    return isMobile ? (
      <ProjectTypeSelectorMobile {...this.props} />
    ) : (
      <ProjectTypeSelectorDesktop {...this.props} />
    );
  }
}

export default ProjectTypeSelector;



// WEBPACK FOOTER //
// ./src/scenes/Home/ProjectTypeSelector.tsx